import PeriodResultTable, { ResultLeague } from "./PeriodResultTable";

const periodColumns = [
  { label: "Game 1", type: "set", number: 1 },
  { label: "Game 2", type: "set", number: 2 },
  { label: "Game 3", type: "set", number: 3 },
];
const summaryColumns = [
  { label: "Total Points", key: "totalScore" },
  { label: "Total Games", key: "totalSets" },
];

const BadmintonResultTable = ({ leagues }: { leagues: ResultLeague[] }) => (
  <PeriodResultTable
    leagues={leagues}
    periodColumns={periodColumns}
    summaryColumns={summaryColumns}
  />
);

export default BadmintonResultTable;
